import { useEffect, useState } from "react";
import { Theme, LOCAL_STORAGE_THEME_KEY } from "shared-types";

export function useTailwindTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(() => {
    if (localStorage.getItem(LOCAL_STORAGE_THEME_KEY) === Theme.Dark)
      return Theme.Dark;

    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? Theme.Dark
      : Theme.Light;
  });

  useEffect(() => {
    const root = document.documentElement;

    if (theme === "dark") {
      root.classList.add(Theme.Dark);
    } else {
      root.classList.remove(Theme.Dark);
    }

    localStorage.setItem(LOCAL_STORAGE_THEME_KEY, theme);
  }, [theme]);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === LOCAL_STORAGE_THEME_KEY && e.newValue) {
        setTheme(e.newValue as Theme);
      }
    };

    window.addEventListener("storage", onStorage);

    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return [
    theme,
    () => setTheme((prev) => (prev === Theme.Dark ? Theme.Light : Theme.Dark)),
  ];
}
